import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_PROPERTY_DOCUMENTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_PROPERTY_DOCUMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_PROPERTY_DOCUMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_PROPERTY_DOCUMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_PROPERTY_DOCUMENT:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
